import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import {
  RadioGroup,
  RadioGroupItem,
} from "@babackapp/customer-ui/components/radio-group";
import type { Resolution } from "@babackapp/return-widget-components/types";
import { RefreshCcw, StoreIcon } from "lucide-react";

type ExchangeResolution = Extract<Resolution, "exchange" | "exchange-credit">;

type Props = {
  value: ExchangeResolution | null;
  onChange: (value: ExchangeResolution) => void;
};

export function ExchangeOptions({ value, onChange }: Props) {
  return (
    <OptionsList>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(v) => onChange(v as ExchangeResolution)}
      >
        <VariantOption />
        <StoreOption />
      </RadioGroup>
    </OptionsList>
  );
}

function VariantOption() {
  return (
    <Label htmlFor="exchange-variant">
      <Option>
        <OptionIcon>
          <RefreshCcw />
        </OptionIcon>
        <OptionTitle>Changer de variante</OptionTitle>
        <OptionDescription>
          Échangez contre une autre taille, couleur ou variante du même article.
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="exchange" id="exchange-variant" />
        </OptionAction>
      </Option>
    </Label>
  );
}

function StoreOption() {
  return (
    <Label htmlFor="exchange-credit">
      <Option>
        <OptionIcon>
          <StoreIcon />
        </OptionIcon>
        <OptionTitle>Explorer la boutique</OptionTitle>
        <OptionDescription>
          Recevez un crédit à utiliser sur n&apos;importe quel article de la
          boutique.
        </OptionDescription>
        <OptionAction>
          <RadioGroupItem value="exchange-credit" id="exchange-credit" />
        </OptionAction>
      </Option>
    </Label>
  );
}
